import { apiUrl } from "@/lib/env";

export type ReferralStatus = {
  approved: boolean;
  referralCode?: string;
  referralLink?: string;
  /** Friends who've used the referral link and joined the waitlist, whether or not they've finished setup yet. */
  invitedCount: number;
  /** Friends who've finished setup — the subset of `invitedCount` that counts toward reward tiers. */
  joinedCount: number;
  rewardTier: number;
  innerCircleEligible: boolean;
};

export type ReferralLookupResult =
  | { ok: true; status: ReferralStatus }
  | { ok: false; error: string; message: string };

export async function lookupReferralStatus(lookup: string): Promise<ReferralLookupResult> {
  try {
    const resp = await fetch(
      apiUrl(`/api/v1/public/waitlist/lookup?lookup=${encodeURIComponent(lookup)}`),
    );
    const data = (await resp.json().catch(() => ({}))) as {
      error?: string;
      message?: string;
      approved?: boolean;
      referralCode?: string;
      referralLink?: string;
      invitedCount?: number;
      joinedCount?: number;
      rewardTier?: number;
      innerCircleEligible?: boolean;
    };
    if (!resp.ok) {
      return {
        ok: false,
        error: data.error ?? "unknown",
        message: data.message ?? "Couldn't load referral status.",
      };
    }
    return {
      ok: true,
      status: {
        approved: data.approved ?? false,
        referralCode: data.referralCode,
        referralLink: data.referralLink,
        invitedCount: data.invitedCount ?? 0,
        joinedCount: data.joinedCount ?? 0,
        rewardTier: data.rewardTier ?? 0,
        innerCircleEligible: data.innerCircleEligible ?? false,
      },
    };
  } catch {
    return { ok: false, error: "network", message: "Couldn't load referral status." };
  }
}
